import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PsuAwardListDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type TableParamsType } from '../../types/common';

const useGetPsuAwardsParticipantApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType & {
    fromApproveDate?: string;
    toApproveDate?: string;
    fromPublishDate?: string;
    toPublishDate?: string;
  }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PsuAwardListDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: psuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    fromApproveDate,
    toApproveDate,
    fromPublishDate,
    toPublishDate,
    _force,
  } = tableInfo;
  const psuStatus = 0;

  const PsuAwardsParticipantApprovalData = useQuery(
    [
      'getPsuAwardsParticipantApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      psuStatus,
      psuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      fromApproveDate,
      toApproveDate,
      fromPublishDate,
      toPublishDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        PsuAwardApprovalService.getApiAwardApiAppPSUAwardApprovalPSUAwardList(
          approvalStatusId ?? [0],
          employeeStatusId ?? [0],
          psuStatus,
          psuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          fromApproveDate,
          toApproveDate,
          fromPublishDate,
          toPublishDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return PsuAwardsParticipantApprovalData;
};

export default useGetPsuAwardsParticipantApprovalList;
